import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  state: string
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '43px minmax(20px, auto)',
    paddingTop: 16,
    paddingLeft: 24,
    paddingBottom: 8
  },

  nameArea: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 16
  },

  nameRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '0.25rem 0px',
    width: 'calc(100% - 1rem)'
  },

  closeButton: {
    marginLeft: '1rem',
    cursor: 'pointer'
  },

  name: {
    color: '#1F1F1F',
    fontStyle: 'normal',
    fontSize: theme.size.base
  },

  timeArea: {
    display: 'flex',
    alignItems: 'center'
  },

  stateArea: {
    display: 'flex',
    fontSize: theme.size.base,
    color: ({ state }) =>
      state === 'CLOSED'
        ? theme.palette.variant.success
        : state === 'ENDED' || state === 'OFFLINE'
        ? '#888888'
        : state === 'IDLE'
        ? '#6D9FFF'
        : state === 'ACTIVE'
        ? theme.palette.primary.main
        : state === 'OVERDUE'
        ? '#FF7A00'
        : theme.palette.variant.error
  },

  icon: {
    margin: '0 3px',
    display: 'flex',
    alignItems: 'center'
  },

  dot: {
    marginRight: '4px',
    color: '#888888'
  },

  time: {
    color: '#888888',
    fontSize: theme.size.sm
  },

  completed: {
    color: theme.palette.variant.success
  },

  rejected: {
    color: theme.palette.variant.error
  }
}))

export default useStyles
